# TODO - use yarn for this later
Papa = require('../../../../../../vendor/assets/javascripts/v2/papaparse');

moduleViewApp.service("CSVParser", ['$q', 'HeaderRowParser', ($q, HeaderRowParser) ->
  (rawCSV) ->
    service =
      parse: ->
        deferred = $q.defer()
        removeTrailingWhitespace = (csv) ->
          csvArr = csv.split("\n")
          for n, index in csvArr
              csvArr[index] = n.trim()
          csv = csvArr.join("\n")
          csv
        removeTrailingNewlines = (csv) ->
          if ["\r\n", "\n", "\r"].indexOf(csv.slice(-1)) != -1
            csv = csv.slice(0, -1)
          csv
        rawCSV = removeTrailingWhitespace(rawCSV)
        rawCSV = removeTrailingNewlines(rawCSV)

        doParse = (options, callback) ->
          Papa.parse rawCSV, _.assignIn({
            skipEmptyLines: true

            complete: (results) ->
              if results.errors.length > 0
                deferred.reject(results.errors)
              else
                callback(results)

            error: (error) ->
              deferred.reject([].concat(error))
          }, options)

        if Papa.parse(rawCSV).data.length > 1
          header_size = 1
        else
          header_size = 0
        doParse({header: header_size, preview: 1}, (results) ->
          headerRow = _.keys(results.data[0])
          headerRowParser = HeaderRowParser(headerRow)
          useHeader = true

          if headerRowParser.hasRequiredHeadings() || headerRow.length != 2
            # Header row specified
            if headerRowParser.errors.length > 0
              # But invalid, abort
              deferred.reject(headerRowParser.errors)
          else
            headerRowParser = HeaderRowParser(["anchor_text", "association_1_text"])
            useHeader = false

          unless useHeader
            headerRowParser.mappers[0] = headerRowParser.mappers.anchor_text
            headerRowParser.mappers[1] = headerRowParser.mappers.association_1_text

          doParse({header: useHeader}, (results) ->

            deferred.resolve _.map results.data, (row, index) ->
              item =
                anchor: {}
                associations: []
              for header, val of row
                try
                  headerRowParser.mappers[header](item, val.trim())
                catch
                  deferred.reject(service.delimiterError(index))
              item
          )
        )

        deferred.promise

      delimiterError: (index) ->
        message: "Error parsing row #{index + 1}"
        row: index

    service
])
